import { render } from "./boardEdit.vue?vue&type=template&id=7688d9f4&scoped=true"
import script from "./boardEdit.vue?vue&type=script&lang=js"
export * from "./boardEdit.vue?vue&type=script&lang=js"

import "./boardEdit.vue?vue&type=style&index=0&id=7688d9f4&scoped=true&lang=css"
import "./boardEdit.vue?vue&type=style&index=1&id=7688d9f4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7688d9f4"]])

export default __exports__